angular.module('app.controllers').controller('MassEditUserCtrl', function ($scope, $stateParams, $state, $translate, notify, api) {
    $scope.statusOptions = [
        { value: 'user_active', label: $translate.instant('user_active') },
        { value: 'user_inactive', label: $translate.instant('user_inactive') },
        { value: 'user_deleted', label: $translate.instant('user_deleted') },
        { value: 'user_suspended', label: $translate.instant('user_suspended') },
    ];

    $scope.userOptions = [];
    api('users')
        .selectize({
            transform: {
                id: 'id',
                value: ':fullname (:job.value)',
            },
        })
        .then((response) => {
            $scope.userOptions = response.data;
            $scope.users = {};
            _.map(response.data, (user) => {
                $scope.users[user.value] = user.label;
            });
        });

    $scope.jobOptions = [];
    api('dictionaries/jobs')
        .selectize()
        .then((response) => {
            $scope.jobOptions = response.data;
        });

    $scope.groupOptions = [];
    api('groups')
        .selectize({ transform: { id: 'id', value: ':name' } })
        .then((response) => {
            $scope.groupOptions = response.data.sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));

            $scope.groups = {};
            _.map(response.data, (group) => {
                $scope.groups[group.value] = group.label;
            });
        });

    $scope.permissionOptions = [];
    api('dictionaries/permissions')
        .selectize()
        .then((response) => {
            // budujemy
            $scope.permissionOptions = _.map(response.data, (row) => {
                const pair = row.label.split('__');
                row.label = [$translate.instant(pair[0]), $translate.instant(`permissions.${pair[1]}`)].join(': ');

                return row;
            });

            // sortujemy
            $scope.permissionOptions = $scope.permissionOptions.sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0));

            $scope.permissions = {};
            _.map(response.data, (permission) => {
                $scope.permissions[permission.value] = permission.label;
            });
        });

    $scope.changes = {};
    $scope.action_all = {};
    $scope.prm_all = {};
    $scope.grp_all = {};

    // zmiany pól wyboru - czyścimy $scope.changes
    $scope.$watch('change_users', (nv, ov) => {
        angular.forEach(_.difference(ov, nv), (uidToRemove) => {
            delete $scope.changes[uidToRemove];
        });
    });
    $scope.$watch('change_permissions', (nv, ov) => {
        angular.forEach(_.difference(ov, nv), (pidToRemove) => {
            angular.forEach($scope.change_users, (u) => {
                if ($scope.changes[u] && $scope.changes[u].permissions) {
                    delete $scope.changes[u].permissions[pidToRemove];
                }
            });
        });
    });
    $scope.$watch('change_groups', (nv, ov) => {
        angular.forEach(_.difference(ov, nv), (gidToRemove) => {
            angular.forEach($scope.change_users, (u) => {
                if ($scope.changes[u] && $scope.changes[u].groups) {
                    delete $scope.changes[u].groups[gidToRemove];
                }
            });
        });
    });

    $scope.$watch('action_all', (nv, ov) => {
        angular.forEach($scope.change_users, (u) => {
            if (!$scope.changes[u]) {
                $scope.changes[u] = {};
            }

            $scope.changes[u].action = nv;
        });
    });
    $scope.togglePerm = (u) => {
        $scope.prm_all[u] = !$scope.prm_all[u];
        angular.forEach($scope.change_permissions, (p) => {
            if (!$scope.changes[u]) {
                $scope.changes[u] = {};
            }
            if (!$scope.changes[u].permissions) {
                $scope.changes[u].permissions = {};
            }

            $scope.changes[u].permissions[p] = $scope.prm_all[u] ? p : 0;
        });
    };
    $scope.toggleGrp = (u) => {
        $scope.grp_all[u] = !$scope.grp_all[u];
        angular.forEach($scope.change_groups, (g) => {
            if (!$scope.changes[u]) {
                $scope.changes[u] = {};
            }
            if (!$scope.changes[u].groups) {
                $scope.changes[u].groups = {};
            }

            $scope.changes[u].groups[g] = $scope.grp_all[u] ? g : 0;
        });
    };

    // zapis
    $scope.saveChanges = () => {
        const info = notify.info($translate.instant('saving'));
        notify.global(1);

        api('users/mass-edit')
            .post({ changes: $scope.changes })
            .then(() => {
                info.close();
                notify.success($translate.instant('saved'));
                notify.global(0);
            });
    };
});
